import { MdAttachFile, MdOpenInNew } from "react-icons/md";
import Text from "../../../../../components/text";
import Subtitle from "../../../../../components/subtitle";

interface Props {
  data: any;
  onOpen: (id: number) => void;
}

const OcorrenciaCardMobile: React.FC<Props> = ({ data, onOpen }) => {
  return (
    <div className="w-full rounded-xl bg-white overflow-hidden shadow-sm mb-4" style={{ border: '1px solid #eee' }}>
      <div className="px-5 pt-3.5 pb-1 border-b border-gray-100 flex justify-between items-center">
        <Text className="!text-[14px] !font-bold">
          Ocorrência #{data["Ocorrência"]}
        </Text>

        <button
          onClick={() => onOpen(data.id)}
          className="flex items-center p-0 gap-1.5 text-[rgb(41,145,214)] text-[10px] font-semibold border-none bg-transparent"
        >
          Mais Informações
          <MdOpenInNew size={12} />
        </button>
      </div>

      <div className="px-6 pt-2.5 pb-3.5 border-b border-gray-100 flex justify-between">
        <div>
          <Subtitle className="!text-gray-400 !text-[11px]">
            Data
          </Subtitle>
          <Text className="!text-[14px]">
            {data["Dt. Abertura"]}
          </Text>
        </div>

        <div className="text-right">
          <Subtitle className="!text-gray-400 !text-[11px]">
            Local
          </Subtitle>
          <Text className="!text-[14px]">
            {data["Local"]}
          </Text>
        </div>
      </div>

      <div className="px-4 py-2.5 bg-[#F3F4F6] mx-4 rounded-md flex justify-between items-center">
        <div>
          <Subtitle className="!text-gray-400 !text-[11px]">
            Situação
          </Subtitle>

          <Text className="!text-[13px] !font-semibold">
            {data["Situação"]}
          </Text>
        </div>

        <div className="text-right">
          <Subtitle className="!text-gray-400 !text-[11px]">
            Ronda
          </Subtitle>

          <Text className="!text-[13px]">
            {data["Ronda"]}
          </Text>
        </div>
      </div>

      <div className="px-6 pb-2.5 pt-3.5 flex justify-between items-center">
        <div>
          <Subtitle className="!text-gray-400 !text-[11px]">
            Motivo
          </Subtitle>
          <Text className="!text-[14px]">
            {data["Motivo"]}
          </Text>
        </div>

        <div className="text-right">
          <Subtitle className="!text-gray-400 !text-[11px]">
            Ponto de Ronda
          </Subtitle>
          <Text className="!text-[14px]">
            {data["Ponto de Ronda"]}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default OcorrenciaCardMobile;